<template>
  <div class="player" @mouseleave="leavePlayer" :class="[lockState ? 'lock' : 'unLock' , playerShowState ? 'show' : 'hide']">
    <div class="hand" @mouseenter="enterPlayer"></div>
    <div class="player-wrap" id="js-audio" :class="playerShowState ? 'show' : 'hide'">
        <!-- <audio id="ez-player" class="video-js"><source src="http://sk.cri.cn/am846.m3u8" type="application/x-mpegURL"></audio> -->
        <!-- <audio id="js-my-audio" class="video-js"><source src="http://resezfm.meldingcloud.com/ueditor/audio/2112/1039131162657.mp3" type="audio/mp3"></audio> -->
    </div>
    <div class="cg-mainWrapper">
        <div class="playerCon" :style="{'--playerTitleScrollStyle':playerTitleScrollStyle}">
            <div class="pic">
                <img v-lazy="{src:curLiveInfo.programUrlTwo,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
            </div>
            <!-- <div class="showName" ref="playerTitleCon" :class="{'scroll':isPlayerTitleScroll}">
                <span ref="playerTitleConTxt">{{curLiveInfo.programTitle}}</span>
            </div> -->
            <div class="showName">
                <div class="showName-con" ref="playerTitleCon" :class="{'scroll':isPlayerTitleScroll}">
                    <span class="showName-item" :class="{'hoverClass':!isLive}" @click="playerToLink" ref="playerTitleConTxt">{{curLiveInfo.programTitle}}</span>
                    <span class="showName-item copy" :class="{'hoverClass':!isLive}" @click="playerToLink">{{curLiveInfo.programTitle}}</span>
                </div>
            </div>
            <div class="btns">
                <div class="btn prevLength" @click="prevLength"></div>
                <div class="btn prevList" :class="{'gray':!isPrevShowsBtn}" @click="prevNextListBtn('prev')"></div>
                <div class="btn player-btn" @click="play" :class="playerState ? 'play' : 'pause'"></div>
                <div class="btn nextList" :class="{'gray':!isNextShowsBtn}" @click="prevNextListBtn('next')"></div>
                <div class="btn nextLength" @click="nextLength"></div>
            </div>
            <div class="showName-m">
                <div class="showName-m-con" ref="playerTitleConWap" :class="{'scroll':isPlayerTitleScrollWap}">
                    <span class="showName-m-item" :class="{'hoverClass':!isLive}" @click="playerToLink" ref="playerTitleConTxtWap">{{curLiveInfo.programTitle}}</span>
                    <span class="showName-m-item copy" :class="{'hoverClass':!isLive}" @click="playerToLink">{{curLiveInfo.programTitle}}</span>
                </div>
            </div>
            <div class="share-btn" @click="share(emailShareUrl,facebookShareUrl,twitterShareUrl,weiboShareUrl,wechatShareUrl)"></div>
            <div class="speed-pc">
                <ul>
                    <li @click="playerSpeed(0.5)" :class="{active:playerSpeedNum==0.5}"><span>0.5X</span></li>
                    <li @click="playerSpeed(1)" :class="{active:playerSpeedNum==1}"><span>1X</span></li>
                    <li @click="playerSpeed(1.5)" :class="{active:playerSpeedNum==1.5}"><span>1.5X</span></li>
                    <li @click="playerSpeed(2)" :class="{active:playerSpeedNum==2}"><span>2X</span></li>
                </ul>
            </div>
            <div class="speed-pad" ref="speedPad">
                <div class="speed-pad-con" @click="isSpeedBtns = !isSpeedBtns">
                    <span>{{playerSpeedNum}}X</span>
                </div>
                <ul :class="{'active':isSpeedBtns}">
                    <li @click="playerSpeed(0.5)" :class="{active:playerSpeedNum==0.5}"><span>0.5X</span></li>
                    <li @click="playerSpeed(1)" :class="{active:playerSpeedNum==1}"><span>1X</span></li>
                    <li @click="playerSpeed(1.5)" :class="{active:playerSpeedNum==1.5}"><span>1.5X</span></li>
                    <li @click="playerSpeed(2)" :class="{active:playerSpeedNum==2}"><span>2X</span></li>
                </ul>
            </div>
            <div class="share-btn-pad" @click="share(emailShareUrl,facebookShareUrl,twitterShareUrl,weiboShareUrl,wechatShareUrl)"></div>
        </div>
    </div>
    <div class="lock" @click="lockState = !lockState">
        <i class="lock-con" :class="{'unLock':!lockState}"></i>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js'
import radiogtag from '../../static/js/radio_ga'
import frenchgtag from '../../static/js/french_ga'
import eventBus from '../../static/js/eventBus'
export default {
  name: 'Player',
  data () {
    return {
      //音频播放器全局变量
      globalPlayer:null,
      initPlayer:true,
      onAirInfoData:{},
      lockState:true,
      playerShowState:true,
      radioListPlayState:0,
      timer:null,
      playerState:false,
      playerSpeedNum:1,
      isSpeedBtns:false,
      isFirstPlay:true,
      isPlayerTitleScroll:false,
      isPlayerTitleScrollWap:false,
      playerTitleScrollStyle:'',
      curEl:null,
      curLiveInfo:{
        columnTitle: '',
        day: '',
        id: '',
        info: '',
        mediaUrl: '',
        programTitle: '',
        programUrl: '',
        programUrlTwo: '',
        startTime: '',
        stopTime: '',
        title: ''
      },
      liveXHR:{
        xhrUrl:'/api/v3/live',
        xhrParam:{
          'groupType':'1',
          'session':'8295f0a6-6804-4d61-8944-4f8d60a71cd4',
        },
      },
      countryCode:'',
      emailShareUrl:'',
      facebookShareUrl:'',
      twitterShareUrl:'',
      weiboShareUrl:'',
      wechatShareUrl:'',
      nextShowsInfo:{},
      prevShowsInfo:{},
      isNextShowsBtn:false,
      isPrevShowsBtn:false,
      curShowsType:null,
      curShowsLink:'',
      isLive:true,
      curShowsId:null,
    }
  },
  methods:{
    leavePlayer(){
        var _this = this;
        if(_this.lockState == false){
            _this.timer = setTimeout(() => {
                _this.playerShowState = false;
            }, 2000);
        }
    },
    enterPlayer(){
        var _this = this;
        if(_this.lockState == false){
            _this.playerShowState = true;
            clearInterval(_this.timer);
        }
    },

    play(){
        var _this = this;
        if(_this.globalPlayer.paused()){
            _this.globalPlayer.play();
            _this.isFirstPlay = false;
        }else{
            _this.globalPlayer.pause();
        }
    },
    /**
     * 音频播放默认参数
     */
    myDefaultOptions:function() {
      var _self = this;
        //pc、pad
        var myOptions = {
            width: 600,
            height: 65,
            controls: true,
            volumePanel: false,
            bigPlayButton: false,
            textTrackDisplay: false,
            posterImage: false,
            errorDisplay: false,
            controlBar: {
                children: [/*'playToggle','currentTimeDisplay','timeDivider','durationDisplay', 'volumePanel',*/'progressControl','liveDisplay'],//包含的子元素以及生成顺序
                //fullscreenToggle:false,//全屏
                //ProgressControl:true,//时间条
            }
        };
        //手机
        var myOptionsMobile = {
            //width:'100%',
            //height:'auto',
            controls: true,
            volumePanel: false,
            bigPlayButton: false,
            textTrackDisplay: false,
            posterImage: false,
            errorDisplay: false,
            controlBar: {
                children: ['progressControl', 'liveDisplay']//包含的子元素以及生成顺序
            }
        };
        var _w = document.documentElement.clientWidth;
        return _w < 544 ? myOptionsMobile : myOptions;
    },

    getLiveInfo(){
      var _this = this , data = [] , radioList = [] , radioInfoList = [];
      _this.$post(_this.liveXHR.xhrUrl,_this.liveXHR.xhrParam,_this).then(async (response)=>{
        data = response.data;
        radioList = data.data;
        for(var j=0;j<radioList.length;j++){
          var _index = j;
          await _this.$post('/api/v3/live/detail?session=8295f0a6-6804-4d61-8944-4f8d60a71cd4&groupType=1&id='+radioList[_index].id+'',{},_this).then(async (response)=>{
            var detailData = response.data.data;
            radioList[_index].columnTitle = detailData.programTitle;
            radioList[_index].programTitle = detailData.title;
            radioList[_index].day = detailData.day;
            if(detailData.picurl1){
              radioList[_index].programUrlTwo = detailData.picurl1;
            }else{
              radioList[_index].programUrlTwo = detailData.programUrl;
            }
            radioList[_index].info = detailData.info;
            if('startTime' in detailData && 'stopTime' in detailData){
              radioList[_index].startTime = detailData.startTime;
              radioList[_index].stopTime = detailData.stopTime;
            }else{
              radioList[_index].startTime = '00:00';
              radioList[_index].stopTime = '23:59';
            }
          })
        }
        _this.curLiveInfo = radioList[_this.radioListPlayState];
        if(_this.curLiveInfo){
            _this.$nextTick(function(){
                _this.init();
            })
        }
      })
    },

    getLiveInfo_static(){
      var _this = this , data = [] , radioList = [] , promiseList  = [] , timer = null;
      _this.$get('/downapiRES/radio/v1/live/groupType1.json',{},_this).then((response)=>{
        data = response.data;
        radioList = data.data;
        for(let j=0;j<radioList.length;j++){
          promiseList.push(new Promise((resolve, reject) => {
            _this.$get('/downapiRES/radio/v1/live/detail/groupType1_id'+radioList[j].id+'.json',{},_this).then((response)=>{
              var detailData = response.data.data;
              radioList[j].columnTitle = detailData.programTitle;
              radioList[j].programTitle = detailData.title;
              radioList[j].day = detailData.day;
              if(detailData.picurl1){
                radioList[j].programUrlTwo = detailData.picurl1;
              }else{
                radioList[j].programUrlTwo = detailData.programUrl;
              }
              radioList[j].info = detailData.info;
              if('startTime' in detailData && 'stopTime' in detailData){
                radioList[j].startTime = detailData.startTime;
                radioList[j].stopTime = detailData.stopTime;
              }else{
                radioList[j].startTime = '00:00';
                radioList[j].stopTime = '23:59';
              }
            })
            resolve(radioList[j])
          }));
        }
        Promise.all(promiseList).then((rspList)=> {
          rspList.map((val)=> {
            
          });
        });
        _this.curLiveInfo = radioList[_this.radioListPlayState];
        if(_this.curLiveInfo){
            _this.$nextTick(function(){
                _this.init();
            })
        }
        timer = setInterval(function(){
            _this.$forceUpdate();
            if($('.playerCon .pic img').length > 0){
                if($('.playerCon .pic img').attr('src').indexOf('http') != -1){
                    clearInterval(timer);
                }
            }
            
        },500)
      })
    },

    reqInit(){
      var _this = this;
      if(_this.isStaticRequest){
        console.log('静态')
        _this.getLiveInfo_static();
      }else{
          console.log('动态')
        _this.getLiveInfo();
      }
    },

    share(emailUrl,facebookUrl,twitterUrl,weiboUrl,wechatUrl){
      var _this = this;
      _this.$shareDialog.showShareDialog({
        title: 'Share',
        link:{
          facebook:facebookUrl,
          twitter:twitterUrl,
          weibo:weiboUrl,
          weixin:wechatUrl,
          email:emailUrl,
        }
      })
    },

    audioPlay:function(id, play, callback) {
      var _self = this , _countryCode = '' , _noPlayCountryCodes = '';
        if(sessionStorage.getItem('countryCode') != null){
            _countryCode = sessionStorage.getItem("countryCode")
            _self.countryCode = _countryCode;
        }else{
            _self.countryCode = '';
        }
        if (!id) {
            var date = new Date();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            var _play = play || false,
                _isLive = false,
                data = {
                    showName: 'cgtn-radio',
                    pic: './img/pic1.jpg',
                    type: 'application/x-mpegURL',
                    url: 'http://sk.cri.cn/915.m3u8'
                };
        } else {
            var _id = id,
                _play = play || false,
                _isLive = _id.attr('data-type') == 'live' ? false : true,
                data = {
                    showName: _id.attr('data-showName') || 'cgtn-radio',
                    pic: _id.attr('data-pic') || './img/pic1.jpg',
                    type: reType(_id.attr('data-type')) || 'application/x-mpegURL',
                    url: _id.attr('data-url') || 'http://sk.cri.cn/915.m3u8',
                    groupName: _id.attr('data-groupname') || 'en',
                    linkUrl: _id.attr('data-linkUrl') || 'https://radio.cgtn.com/',
                };
            if(data.linkUrl.indexOf('/podcast/news/') != -1){
                let mediaUrlArr = data.linkUrl.split('/');
                if(mediaUrlArr[5] && mediaUrlArr[7]){
                    _self.curShowsId = mediaUrlArr[7];
                    _self.prevNextInfo(mediaUrlArr[5],mediaUrlArr[7]);
                }
            }
            
            _noPlayCountryCodes = _id.attr('data-countryCode');
            _self.curEl = id;
            let urlTitle = _self.filterUrl(data.showName);
            _self.emailShareUrl = 'mailto:?subject='+data.showName+'&body='+data.linkUrl+'';
            _self.facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?display=popup&app_id=723054267828678&u='+data.linkUrl+'';
            _self.twitterShareUrl = 'https://twitter.com/intent/tweet?text=Radio%20-CGTN%20-%20'+urlTitle+'&url='+data.linkUrl+'';
            _self.weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data.showName+'&pic='+data.pic+'&url='+data.linkUrl+'';
            _self.wechatShareUrl = data.linkUrl;

            if(_self.$matomo){
                _self.$matomo.trackEvent('audio', 'playClkNum', id.attr('data-linkurl'), 1);
            }
            if(radiogtag){
                radiogtag.event('audio', 'playClkNum', id.attr('data-linkurl'), 1)
            }
            if(data.groupName === 'fr'){
                if(frenchgtag){
                    frenchgtag.event('audio', 'playClkNum', id.attr('data-linkurl'), 1)
                }
            }
        }

        /**
         * 返回格式类型
         */
        function reType(type) {
            var _type = type || 'application/x-mpegURL';
            switch (_type) {
                case 'live':
                    _type = 'application/x-mpegURL';
                    break;
                case 'mp3':
                    _type = 'audio/mpeg';
                    break;
                default:
                    break;
            }
            return _type;
        };

        //判断是不是直播，不是直播则添加上一条下一条事件
        if (_isLive) {
            
        } else {
            
        }
        if(_noPlayCountryCodes && _self.countryCode){
            if(_noPlayCountryCodes.indexOf(_self.countryCode) != -1){
                _self.$dangerIpDialog.showDangerIpDialog();
                return false;
            }
        }
        $('.playerCon .pic img').attr('src',data.pic);
        $('.playerCon .showName span').text(data.showName);
        $('.playerCon .showName-m span').text(data.showName);
        _self.curShowsLink = data.linkUrl;
        _self.playerSpeedNum = 1;
        _self.globalPlayer.playbackRate(_self.playerSpeedNum);
        if (_play) {
            

            if(_self.isFirstPlay == true){
                console.log('第一次播放');
                if(data.url == _self.globalPlayer.src()){
                    _self.globalPlayer.play();
                    $('.js-play').removeClass('pause').addClass('play');
                    _id.removeClass('play').addClass('pause');
                }else{
                    _self.globalPlayer.src({
                        src: data.url,
                        type: data.type
                    });
                    _self.globalPlayer.play();
                    $('.js-play').removeClass('pause').addClass('play');
                    _id.removeClass('play').addClass('pause');
                }
                _self.isFirstPlay = false;
            }else{
                if(_self.globalPlayer.paused()){
                    if(data.url == _self.globalPlayer.src()){
                        _self.globalPlayer.play();
                        $('.js-play').removeClass('pause').addClass('play');
                        _id.removeClass('play').addClass('pause');
                    }else{
                        _self.globalPlayer.src({
                            src: data.url,
                            type: data.type
                        });
                        _self.globalPlayer.play();
                        $('.js-play').removeClass('pause').addClass('play');
                        _id.removeClass('play').addClass('pause');
                    }
                }else{
                    if(data.url == _self.globalPlayer.src()){
                        console.log('第二次点击')
                        _self.globalPlayer.pause();
                        _id.removeClass('pause').addClass('play');
                    }else{
                        _self.globalPlayer.src({
                            src: data.url,
                            type: data.type
                        });
                        _self.globalPlayer.play();
                        $('.js-play').removeClass('pause').addClass('play');
                        _id.removeClass('play').addClass('pause');
                    }
                }
            }
        }
        _self.playerTitleScroll();
        _self.playerTitleScrollWap();
        if (callback) {
            callback();
        }
    },
    
    /**
     * 音频播放器初始化
     */
    audioInit:function(){
      var _self = this , timer = null;
        //刷新时需要先注销
        if($('#js-my-audio').length>0){
            //globalPlayer = videojs('js-my-audio');
            // globalPlayer.dispose();
        }

        $('#js-audio').html('<audio id="js-my-audio" class="video-js"><source src="'+_self.curLiveInfo.mediaUrl+'" type="application/x-mpegURL"></audio>');

        //重载
        _self.globalPlayer = videojs('js-my-audio',_self.myDefaultOptions());  //初始化视频
        timer = setInterval(function(){
            if(_self.curLiveInfo.programTitle != undefined){
                _self.emailShareUrl = 'mailto:?subject='+_self.curLiveInfo.programTitle+'&body=https://radio.cgtn.com/';
                _self.facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?display=popup&app_id=723054267828678&u=https://radio.cgtn.com/';
                _self.twitterShareUrl = 'https://twitter.com/intent/tweet?text='+_self.curLiveInfo.programTitle+'&url=https://radio.cgtn.com/';
                _self.weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+_self.curLiveInfo.programTitle+'&pic='+_self.curLiveInfo.programUrlTwo+'&url=https://radio.cgtn.com/';
                _self.wechatShareUrl = 'https://radio.cgtn.com/';
                clearInterval(timer);
            }
        },500)
        // $('#js-audio').html('<audio id="js-my-audio" class="video-js"><source src="http://resezfm.meldingcloud.com/ueditor/audio/2112/1039131162657.mp3" type="audio/mp3"></audio>');
        
        

        _self.globalPlayer.on('loadedmetadata',function(){  //加载
            _self.setDataTime('load');
		});
		_self.globalPlayer.on('play',function(){ //播放
            _self.playerState = true;
            _self.$nextTick(function(){
                $('.vjs-play-progress').removeClass('end');
            })
            if(_self.globalPlayer.cache_.source.type == 'application/x-mpegURL'){
                $('.js-live-play').removeClass('play').addClass('pause');
                _self.isLive = true;
            }else{
                _self.isLive = false;
            }
            if(_self.curEl){
                _self.curEl.removeClass('play').addClass('pause');
            }
            _self.setDataTime('start');
            sessionStorage.setItem("curShowsUrl", _self.curShowsLink);
            eventBus.$emit('pushCurShowsUrl',_self.curShowsLink)
		})
        _self.globalPlayer.on('progress',function(){ //播放中
            
		})
		_self.globalPlayer.on('pause',function(){  //暂停
            _self.playerState = false;
            $('.js-play').removeClass('pause').addClass('play');
            _self.setDataTime('stop');
            // _self.$refs.playerTitleConTxt.style.animationPlayState = 'paused';
		});
        _self.globalPlayer.on('ended',function(){  //结束
            _self.$nextTick(function(){
                $('.vjs-play-progress').addClass('end');
            })
		});
    },

    playerKeyDown:function(e){
		var _self = this;
        var key = window.event ? e.keyCode : e.which;
		switch(key){
			case 37 ://作
			    console.log('快退');
				_self.globalPlayer.currentTime(_self.globalPlayer.currentTime() - 20);
				break;
			case 39 ://右
                console.log('快进');
				_self.globalPlayer.currentTime(_self.globalPlayer.currentTime() + 20);
				break;
		}
		return false;
	},

    playerSpeed:function(speedNum){
        var _self = this;
        _self.playerSpeedNum = speedNum;
        _self.globalPlayer.playbackRate(_self.playerSpeedNum);
    },
    docClick(event){
        var _self = this;
        var dom = _self.$refs.speedPad;
        if(!dom.contains(event.target)){
            if(_self.isSpeedBtns){
                _self.isSpeedBtns = false;
            }
        }
    },
    playerTitleScroll(){
        var _self = this , parDom , childDom , timer , offsetWidth;
        parDom = _self.$refs.playerTitleCon.clientWidth;
        timer = setInterval(function(){
            if(_self.curLiveInfo.programTitle){
                childDom = _self.$refs.playerTitleConTxt.clientWidth;
                offsetWidth = childDom + 10;
                if(childDom > parDom){
                    _self.isPlayerTitleScroll = true;
                    _self.playerTitleScrollStyle = 'translateX(-'+offsetWidth+'px)';
                    _self.$refs.playerTitleCon.style.animationName = 'playerTitleScroll';
                }else{
                    _self.isPlayerTitleScroll = false;
                    _self.$refs.playerTitleCon.style.animationName = 'initial';
                }
                clearInterval(timer);
            }
        },100)
    },
    playerTitleScrollWap(){
        var _self = this , parDom , childDom , timer , offsetWidth;
        parDom = _self.$refs.playerTitleConWap.clientWidth;
        timer = setInterval(function(){
            if(_self.curLiveInfo.programTitle){
                childDom = _self.$refs.playerTitleConTxtWap.clientWidth;
                offsetWidth = childDom + 10;
                if(childDom > parDom){
                    _self.isPlayerTitleScrollWap = true;
                    _self.playerTitleScrollStyle = 'translateX(-'+offsetWidth+'px)';
                    _self.$refs.playerTitleConWap.style.animationName = 'playerTitleScroll';
                }else{
                    _self.isPlayerTitleScrollWap = false;
                    _self.$refs.playerTitleConWap.style.animationName = 'initial';
                }
                clearInterval(timer);
            }
        },100)
    },

    /**
     * 整体函数调用相关
     */
    init:function() {
        var _self = this;
        if ($('#js-audio').length > 0) {
            _self.audioInit();//初始
            _self.playerTitleScroll();
            _self.playerTitleScrollWap();
        }
    },
    prevLength(){
        var _this = this;
        _this.globalPlayer.currentTime(_this.globalPlayer.currentTime() - 20);
    },
    nextLength(){
        var _this = this;
        _this.globalPlayer.currentTime(_this.globalPlayer.currentTime() + 20);
    },
    removeDomainFromUrl(inputUrl){
        var url = new URL(inputUrl);
        var pathAndQuery = url.pathname + url.search + url.hash;
        return pathAndQuery;
    },
    playerToLink(){
        let oldUrl = this.curShowsLink , newUrl = '';
        if(oldUrl !== ''){
            newUrl = this.removeDomainFromUrl(oldUrl);
            console.log(newUrl);
            if(newUrl !== ''){
                this.$router.push(newUrl);
            }
        }
    },
    prevNextInfo(showsType,showsId){
        let that = this , _data = null , prevData = {} , nextData = {};
        if(showsType != ''){
            that.curShowsType = showsType;
        }
        that.$get('/downapiRES/radio/v1/program/preNextHistory/type'+showsType+'/id'+showsId+'.json',{},that).then((response)=>{
            if(response.data.status === '1'){
                _data = response.data.data;
                if(JSON.stringify(_data.preHistory) !== '{}'){
                    prevData = _data.preHistory;
                    that.prevShowsInfo = prevData;
                    that.isPrevShowsBtn = true;
                }else{
                    that.isPrevShowsBtn = false;
                }
                if(JSON.stringify(_data.nextHistory) !== '{}'){
                    nextData = _data.nextHistory;
                    that.nextShowsInfo = nextData;
                    that.isNextShowsBtn = true;
                }else{
                    that.isNextShowsBtn = false;
                }
            }else{
                console.log('请求失败');
            }
        }).catch((error)=>{
            that.prevShowsInfo = {};
            that.isPrevShowsBtn = false;
            that.nextShowsInfo = {};
            that.isNextShowsBtn = false;
        })
    },
    prevNextListBtn(flag){
        let _self = this , showsData = '';
        if(flag === 'prev'){
            showsData = _self.prevShowsInfo;
        }else{
            showsData = _self.nextShowsInfo;
        }
        let _countryCode = '' , _noPlayCountryCodes = '';
        let play = true;
        console.log(showsData)
        if(sessionStorage.getItem('countryCode') != null){
            _countryCode = sessionStorage.getItem("countryCode")
            _self.countryCode = _countryCode;
        }else{
            _self.countryCode = '';
        }
        if (JSON.stringify(showsData) === '{}') {
            var date = new Date();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            var _play = play || false,
                _isLive = false,
                data = {
                    showName: 'cgtn-radio',
                    pic: './img/pic1.jpg',
                    type: 'application/x-mpegURL',
                    url: 'http://sk.cri.cn/915.m3u8'
                };
        } else {
            var urlTitle = _self.filterUrl(showsData.title);
            var _play = play || false,
                _isLive = true,
                data = {
                    showName: showsData.title || 'cgtn-radio',
                    pic: showsData.picUrl || './img/pic1.jpg',
                    type: 'audio/mpeg',
                    url: showsData.mediaUrl || 'http://sk.cri.cn/915.m3u8',
                    groupName: showsData.groupName || 'en',
                    linkUrl: 'https://radio.cgtn.com/podcast/news/'+_self.curShowsType+'/'+urlTitle+'/'+showsData.id,
                };
            if(data.linkUrl.indexOf('/podcast/news/') != -1){
                let mediaUrlArr = data.linkUrl.split('/');
                if(mediaUrlArr[5] && mediaUrlArr[7]){
                    _self.curShowsId = mediaUrlArr[7];
                    _self.prevNextInfo(mediaUrlArr[5],mediaUrlArr[7]);
                }
            }
            
            _noPlayCountryCodes = showsData.countryRegionLimit;
            _self.emailShareUrl = 'mailto:?subject='+data.showName+'&body='+data.linkUrl+'';
            _self.facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?display=popup&app_id=723054267828678&u='+data.linkUrl+'';
            _self.twitterShareUrl = 'https://twitter.com/intent/tweet?text=Radio%20-CGTN%20-%20'+urlTitle+'&url='+data.linkUrl+'';
            _self.weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data.showName+'&pic='+data.pic+'&url='+data.linkUrl+'';
            _self.wechatShareUrl = data.linkUrl;

            if(_self.$matomo){
                _self.$matomo.trackEvent('audio', 'playClkNum', data.linkUrl, 1);
            }
            if(radiogtag){
                radiogtag.event('audio', 'playClkNum', data.linkUrl, 1)
            }
            if(data.groupName === 'fr'){
                if(frenchgtag){
                    frenchgtag.event('audio', 'playClkNum', data.linkUrl, 1)
                }
            }
        }

        //判断是不是直播，不是直播则添加上一条下一条事件
        if (_isLive) {
           
        } else {
            
        }
        if(_noPlayCountryCodes && _self.countryCode){
            if(_noPlayCountryCodes.indexOf(_self.countryCode) != -1){
                _self.$dangerIpDialog.showDangerIpDialog();
                return false;
            }
        }
        $('.playerCon .pic img').attr('src',data.pic);
        $('.playerCon .showName span').text(data.showName);
        $('.playerCon .showName-m span').text(data.showName);
        _self.curShowsLink = data.linkUrl;
        _self.playerSpeedNum = 1;
        _self.globalPlayer.playbackRate(_self.playerSpeedNum);
        if (_play) {
            _self.globalPlayer.src({
                src: data.url,
                type: data.type
            });
            _self.globalPlayer.play();
        }
        _self.playerTitleScroll();
        _self.playerTitleScrollWap();
    },
    setDataTime(isPlay){
        var _this = this , _isPlay = isPlay , _el = $('.vjs-slider-bar') , playerTimer = null;
        if(_el.length > 0){
            if(isPlay === 'start'){
                if(playerTimer != null){//判断计时器是否为空
                    clearInterval(playerTimer);
                    playerTimer=null;
                }
                playerTimer = setInterval(function(){
                    _el.attr('data-time',''+_this.resetTime(_this.globalPlayer.currentTime())+'/'+_this.resetTime(_this.globalPlayer.duration())+'');
                },100)
            }else if(isPlay === 'stop'){
                clearInterval(playerTimer);
                playerTimer = null;
            }else{
                _el.attr('data-time',''+_this.resetTime(_this.globalPlayer.currentTime())+'/'+_this.resetTime(_this.globalPlayer.duration())+'');
                if(playerTimer != null){//判断计时器是否为空
                    clearInterval(playerTimer);
                    playerTimer=null;
                }
            }
        }
    },
    resetTime(times){
        var result = '00:00';
        var hour,minute,second
        if (times > 0) {
            hour = Math.floor(times / 3600);
            if (hour < 10) {
                hour = "0"+hour;
            }
            minute = Math.floor((times - 3600 * hour) / 60);
            if (minute < 10) {
                minute = "0"+minute;
            }
    
            second = Math.floor((times - 3600 * hour - 60 * minute) % 60);
            if (second < 10) {
                second = "0"+second;
            }
            if (hour == '00') {
                result = minute+':'+second;
            } else if (minute == '00'){
                result = hour+':'+minute+':'+second;
            } else {
                result = second;
        }
        }
        return result;  
    },
    getSession(){
      var _this = this ,  _index = 0;
      if(sessionStorage.getItem('radioIndex') != null){
        _index = sessionStorage.getItem("radioIndex")
        _this.radioListPlayState = _index;
      }else{
        _this.radioListPlayState = 0;
      }
    },
    share(emailUrl,facebookUrl,twitterUrl,weiboUrl,wechatUrl){
      var _this = this;
      _this.$shareDialog.showShareDialog({
        title: 'Share',
        link:{
          facebook:facebookUrl,
          twitter:twitterUrl,
          weibo:weiboUrl,
          weixin:wechatUrl,
          email:emailUrl,
        }
      })
    },
  },
  created(){
    
  },
  mounted:function(){
    this.getSession();
    // this.getLiveInfo_static();
    this.reqInit();
    document.addEventListener('keydown', this.playerKeyDown);
    document.addEventListener('click', this.docClick);
  },
}
</script>

<style scoped lang="scss">
.player{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 53px;
    z-index: 9999;
    background-color: rgba(0,0,0,.85);
    transition: all 0.2s;
    &.unLock{
        &.show{
            bottom: 0;
        }
        &.hide{
            bottom: -53px;
        }
    }
    .hand{
        position: absolute;
        top: -20px;
        left: 0;
        height: 20px;
        width: 100%;
    }
    .lock{
        width: 20px;
        height: 20px;
        background: url('../../static/img/lock-con.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: -20px;
        right: 183px;
        cursor: pointer;
        .lock-con{
            width: 11px;
            height: 14px;
            background: url('../../static/img/lock.png') no-repeat;
            background-size: 100% 100%;
            display: block;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%,0);
            &.unLock{
                background: url('../../static/img/unLock.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .player-wrap{
        /deep/ .video-js{
            width: 100%;
            background-color: transparent;
            height: 3px;
            // .vjs-loading-spinner{
            //     width: 30px;
            //     height: 30px;
            //     border: 4px solid #000;
            //     margin: 0;
            //     border-radius: 15px;
            //     &::before{
            //         border-color:#bfae61;
            //     }
            //     &::after{
            //         border-color:#bfae61;
            //     }
            // }
            &.vjs-seeking{
                .vjs-loading-spinner{
                    display: none;
                }
            }
            &.vjs-waiting{
                .vjs-loading-spinner{
                    display: none;
                }
            }
            .vjs-control-bar{
                display: flex;
                top: 0;
                bottom: auto;
                height: auto;
                background-color: transparent;
                .vjs-live-control{
                    display: none;
                }
                .vjs-icon-previous-item , .vjs-icon-next-item{
                    display: none;
                }
                .vjs-progress-control{
                    .vjs-progress-holder{
                        background-color: #dddddd;
                        margin: 0px;
                        height: 3px;
                        .vjs-load-progress{
                            display: none !important;
                        }
                        .vjs-play-progress{
                            background-color: #bfae61;
                            .vjs-time-tooltip{
                                display: none;
                            }
                            &::before{
                                content: attr(data-time);
                                top: 50%;
                                height: 15px;
                                background-color: #bfae61;
                                line-height: 17px;
                                font-size: 12px;
                                padding: 0 14px;
                                right: 0;
                                transform: translate(100%, -50%);
                                border-radius: 7.5px;
                                font-family: Arial, Helvetica, sans-serif;
                                color: #000000;
                            }
                            &.end::before{
                                transform: translate(0%, -50%);
                            }
                        }
                    }
                    &:hover{
                        .vjs-progress-holder{
                            font-size: 1em;
                        }
                    }
                    .vjs-mouse-display{
                        display: none !important;
                    }
                }
                // .demand-player .video-js .vjs-progress-control .vjs-progress-holder{background-color: #dddddd;margin: 0px;height: 3px;}
                // .demand-player .video-js .vjs-progress-control:hover .vjs-progress-holder{font-size: 1em;}
                // .demand-player .video-js .vjs-progress-control .vjs-mouse-display{display: none !important;}
                // .demand-player .video-js .vjs-load-progress{display: none !important;}
                // .demand-player .video-js .vjs-play-progress{background-color: #c8463c;}
                // .demand-player .video-js .vjs-play-progress:before{content: attr(data-time);top: 50%;height: 19px;background: url(../img/player-slideBar.png) no-repeat;background-size: 100% 100%;line-height: 19px;font-size: 16px;padding: 0 8px;line-height: 15.5px;transform: translate(42%, -50%);}
            }
        }
        &.hide{
            /deep/ .video-js{
                .vjs-control-bar{
                    .vjs-progress-control{
                        .vjs-progress-holder{
                            .vjs-play-progress{
                                &::before{
                                    display: none;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .cg-mainWrapper{
        .playerCon{
            height: 50px;
            position: relative;
            .pic{
                float: left;
                width: 42px;
                height: 100%;
                overflow: hidden;
                position: relative;
                img{
                    width: 42px;
                    height: auto;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
            .columnName{
                float: left;
                height: 100%;
                color: #ffffff;
                font: 400 16px/50px HelveticaLTPro-Bold;
                margin-left: 14px;
                width: 100px;
                overflow: hidden;
            }
            .showName{
                float: left;
                height: 100%;
                margin-left: 14px;
                width: 540px;
                overflow: hidden;
                position: relative;
                .showName-con{
                    height: 100%;
                    margin: 0;
                    padding: 0;
                    position: relative;
                    color: #ffffff;
                    font: 400 16px/50px HelveticaLTPro-Roman;
                    white-space: nowrap;
                    .showName-item{
                        display: inline-block;
                        pointer-events: none;
                        &.hoverClass{
                            cursor: pointer;
                            pointer-events: auto;
                        }
                        &.copy{
                            display: none;
                            margin-left: 10px;
                        }
                    }
                }
                
            }
            .btns{
                height: 100%;
                position: absolute;
                left: 50%;
                top: 0;
                transform: translate(-50%,0);
                .btn{
                    margin-left: 30px;
                    &:first-child{
                        margin-left: 0;
                    }
                }
                .prevLength{
                    float: left;
                    width: 33px;
                    height: 100%;
                    background: url('../../static/img/prevLength.png') no-repeat center center;
                    background-size: 33px 33px;
                    cursor: pointer;
                }
                .nextLength{
                    float: left;
                    width: 33px;
                    height: 100%;
                    background: url('../../static/img/nextLength.png') no-repeat center center;
                    background-size: 33px 33px;
                    cursor: pointer;
                    
                }
                .prevList{
                    float: left;
                    width: 33px;
                    height: 100%;
                    background: url('../../static/img/prevList.png') no-repeat center center;
                    background-size: 30px 30px;
                    cursor: pointer;
                    &.gray{
                        opacity: .5;
                        pointer-events: none;
                    }
                }
                .nextList{
                    float: left;
                    width: 33px;
                    height: 100%;
                    background: url('../../static/img/nextList.png') no-repeat center center;
                    background-size: 30px 30px;
                    cursor: pointer;
                    &.gray{
                        opacity: .5;
                        pointer-events: none;
                    }
                }
                .player-btn{
                    float: left;
                    width: 24px;
                    height: 100%;
                    cursor: pointer;
                    &.pause{
                        background: url('../../static/img/play-btn-white.png') no-repeat center center;
                        background-size: 24px 30px;
                    }
                    &.play{
                        background: url('../../static/img/pause-btn-white.png') no-repeat center center;
                        background-size: 24px 30px;
                    }
                }
            }
            .speed-pc{
                float: right;
                ul{
                    height: 32px;
                    border: 2px solid #fff;
                    border-radius: 16px;
                    padding: 0 13px;
                    margin-top: 9px;
                    li{
                        float: left;
                        margin-left: 14px;
                        cursor: pointer;
                        user-select: none;
                        &:first-child{
                            margin-left: 0px;
                        }
                        span{
                            color: #fff;
                            font: 400 14px/32px HelveticaLTPro-Roman;
                        }
                        &:hover{
                            span{
                                color: #d6bd59;
                            }
                        }
                        &.active{
                            span{
                                color: #d6bd59;
                            }
                        }
                    }
                }
            }
            .speed-pad{
                display: none;
            }
            .share-btn-pad{
                display: none;
            }
            .showName-m{
                display: none;
            }
            .share-btn{
                float: right;
                width: 32px;
                height: 100%;
                background: url('../../static/img/share.png') no-repeat center center;
                background-size: 32px 32px;
                cursor: pointer;
                margin-left: 25px;
            }
        }
    }
}
@media screen and (max-width: 1560px) and (min-width: 1261px){
    .player{
        .cg-mainWrapper{
            .playerCon{
                .columnName{
                    margin-left: 14px;
                }
                .showName{
                    margin-left: 14px;
                    width: 430px;
                }
                .btns{
                    .btn{
                        margin-left: 20px;
                        &:first-child{
                            margin-left: 0;
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 1260px) and (min-width: 769px){
    .player{
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 83px;
        z-index: 9999;
        background-color: rgba(0,0,0,.85);
        transition: all 0.2s;
        &.unLock{
            &.show{
                bottom: 0;
            }
            &.hide{
                bottom: -53px;
            }
        }
        .hand{
            display: none;
        }
        .lock{
            display: none;
        }
        .player-wrap{
            /deep/ .video-js{
                width: 100%;
                background-color: transparent;
                height: 3px;
                .vjs-control-bar{
                    display: flex;
                    top: 0;
                    bottom: auto;
                    height: auto;
                    background-color: transparent;
                    .vjs-icon-previous-item , .vjs-icon-next-item{
                        display: none;
                    }
                    .vjs-progress-control{
                        .vjs-progress-holder{
                            background-color: #dddddd;
                            margin: 0px;
                            height: 3px;
                            .vjs-load-progress{
                                display: none !important;
                            }
                            .vjs-play-progress{
                                background-color: #bfae61;
                                .vjs-time-tooltip{
                                    display: none;
                                }
                                &::before{
                                    content: attr(data-time);
                                    top: 50%;
                                    height: 15px;
                                    right: 0;
                                    background-color: #bfae61;
                                    line-height: 17px;
                                    font-size: 12px;
                                    padding: 0 14px;
                                    transform: translate(100%, -50%);
                                    border-radius: 7.5px;
                                    font-family: Arial, Helvetica, sans-serif;
                                    color: #000000;
                                }
                                &.end::before{
                                    transform: translate(0%, -50%);
                                }
                            }
                        }
                        &:hover{
                            .vjs-progress-holder{
                                font-size: 1em;
                            }
                        }
                        .vjs-mouse-display{
                            display: none !important;
                        }
                    }
                    // .demand-player .video-js .vjs-progress-control .vjs-progress-holder{background-color: #dddddd;margin: 0px;height: 3px;}
                    // .demand-player .video-js .vjs-progress-control:hover .vjs-progress-holder{font-size: 1em;}
                    // .demand-player .video-js .vjs-progress-control .vjs-mouse-display{display: none !important;}
                    // .demand-player .video-js .vjs-load-progress{display: none !important;}
                    // .demand-player .video-js .vjs-play-progress{background-color: #c8463c;}
                    // .demand-player .video-js .vjs-play-progress:before{content: attr(data-time);top: 50%;height: 19px;background: url(../img/player-slideBar.png) no-repeat;background-size: 100% 100%;line-height: 19px;font-size: 16px;padding: 0 8px;line-height: 15.5px;transform: translate(42%, -50%);}
                }
            }
            &.hide{
                /deep/ .video-js{
                    .vjs-control-bar{
                        .vjs-progress-control{
                            .vjs-progress-holder{
                                .vjs-play-progress{
                                    &::before{
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .cg-mainWrapper{
            .playerCon{
                height: 80px;
                padding: 0 16px;
                .pic{
                    float: left;
                    width: 56px;
                    height: 100%;
                    overflow: hidden;
                    position: relative;
                    img{
                        width: 56px;
                        height: auto;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    }
                }
                .columnName{
                    float: left;
                    height: 100%;
                    color: #ffffff;
                    font: 400 16px/80px HelveticaLTPro-Bold;
                    margin-left: 14px;
                    width: 98px;
                    overflow: hidden;
                }
                .showName{
                    float: left;
                    height: 100%;
                    margin-left: 14px;
                    width: 306px;
                    overflow: hidden;
                    position: relative;
                    .showName-con{
                        font: 400 14px/80px HelveticaLTPro-Roman;
                    }
                }
                .btns{
                    left: auto;
                    right: auto;
                    transform: initial;
                    position: initial;
                    float: left;
                    margin-left: 20px;
                    .btn{
                        margin-left: 20px;
                        &:first-child{
                            margin-left: 0;
                        }
                    }
                    .prevLength{
                        float: left;
                        width: 33px;
                        height: 100%;
                        background: url('../../static/img/prevLength.png') no-repeat center center;
                        background-size: 32px 32px;
                        cursor: pointer;
                    }
                    .nextLength{
                        float: left;
                        width: 33px;
                        height: 100%;
                        background: url('../../static/img/nextLength.png') no-repeat center center;
                        background-size: 32px 32px;
                        cursor: pointer;
                    }
                    .player-btn{
                        float: left;
                        width: 24px;
                        height: 100%;
                        cursor: pointer;
                        &.pause{
                            background: url('../../static/img/play-btn-white.png') no-repeat center center;
                            background-size: 24px 30px;
                        }
                        &.play{
                            background: url('../../static/img/pause-btn-white.png') no-repeat center center;
                            background-size: 24px 30px;
                        }
                    }
                }
                .speed-pc{
                    display: none;
                }
                .speed-pad{
                    display: block;
                    float: left;
                    margin-left: 20px;
                    position: relative;
                    .speed-pad-con{
                        width: 32px;
                        height: 32px;
                        font: 400 12px/30px HelveticaLTPro-Roman;
                        color: #fff;
                        text-align: center;
                        border: 3px solid #fff;
                        border-radius: 50%;
                        margin-top: 24px;
                        cursor: pointer;
                        user-select: none;
                    }
                    ul{
                        width: 32px;
                        border: 3px solid #fff;
                        border-radius: 16px;
                        background-color: rgba(0, 0, 0, 0.85);
                        position: absolute;
                        transform: translate(-3px, -156px);
                        box-sizing: initial;
                        padding: 12px 0;
                        display: none;
                        li{
                            text-align: center;
                            margin-top: 10px;
                            cursor: pointer;
                            user-select: none;
                            &:first-child{
                                margin-top: 0px;
                            }
                            span{
                                display: block;
                                font: 400 12px/14px HelveticaLTPro-Roman;
                                color: #fff;
                            }
                            &:hover{
                                span{
                                    color: #d6bd59;
                                }
                            }
                            &.active{
                                span{
                                    color: #d6bd59;
                                }
                            }
                        }
                        &.active{
                            display: block;
                        }
                    }
                }
                .share-btn{
                    display: none;
                }
                .share-btn-pad{
                    display: block;
                    float: left;
                    margin-left: 20px;
                    width: 32px;
                    height: 100%;
                    background: url('../../static/img/share.png') no-repeat center center;
                    background-size: 32px 32px;
                    cursor: pointer;
                }
            }
        }
    }
}
@media screen and (max-width: 768px){
    .player{
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3.89rem;
        z-index: 9999;
        background-color: rgba(0,0,0,.85);
        transition: all 0.2s;
        &.unLock{
            &.show{
                bottom: 0;
            }
            &.hide{
                bottom: -53px;
            }
        }
        .hand{
            display: none;
        }
        .lock{
            display: none;
        }
        .player-wrap{
            /deep/ .video-js{
                width: 100%;
                background-color: transparent;
                height: .17rem;
                .vjs-control-bar{
                    display: flex;
                    top: 0;
                    bottom: auto;
                    height: auto;
                    background-color: transparent;
                    .vjs-icon-previous-item , .vjs-icon-next-item{
                        display: none;
                    }
                    .vjs-progress-control{
                        .vjs-progress-holder{
                            background-color: #dddddd;
                            margin: 0px;
                            height: .17rem;
                            .vjs-load-progress{
                                display: none !important;
                            }
                            .vjs-play-progress{
                                background-color: #bfae61;
                                .vjs-time-tooltip{
                                    display: none;
                                }
                                &::before{
                                    content: attr(data-time);
                                    top: 50%;
                                    height: 15px;
                                    right: 0;
                                    background-color: #bfae61;
                                    line-height: 17px;
                                    font-size: 12px;
                                    padding: 0 14px;
                                    transform: translate(100%, -50%);
                                    border-radius: 7.5px;
                                    font-family: Arial, Helvetica, sans-serif;
                                    color: #000000;
                                    cursor: pointer !important;
                                }
                                &.end::before{
                                    transform: translate(0%, -50%);
                                }
                            }
                        }
                        &:hover{
                            .vjs-progress-holder{
                                font-size: 1em;
                            }
                        }
                        .vjs-mouse-display{
                            display: none !important;
                        }
                    }
                    // .demand-player .video-js .vjs-progress-control .vjs-progress-holder{background-color: #dddddd;margin: 0px;height: 3px;}
                    // .demand-player .video-js .vjs-progress-control:hover .vjs-progress-holder{font-size: 1em;}
                    // .demand-player .video-js .vjs-progress-control .vjs-mouse-display{display: none !important;}
                    // .demand-player .video-js .vjs-load-progress{display: none !important;}
                    // .demand-player .video-js .vjs-play-progress{background-color: #c8463c;}
                    // .demand-player .video-js .vjs-play-progress:before{content: attr(data-time);top: 50%;height: 19px;background: url(../img/player-slideBar.png) no-repeat;background-size: 100% 100%;line-height: 19px;font-size: 16px;padding: 0 8px;line-height: 15.5px;transform: translate(42%, -50%);}
                }
            }
            &.hide{
                /deep/ .video-js{
                    .vjs-control-bar{
                        .vjs-progress-control{
                            .vjs-progress-holder{
                                .vjs-play-progress{
                                    &::before{
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .cg-mainWrapper{
            .playerCon{
                height: 3.72rem;
                padding: 0 .89rem;
                .pic{
                    display: none;
                }
                .columnName{
                    display: none;
                }
                .showName{
                    display: none;
                }
                .btns{
                    position: relative;
                    left: auto;
                    right: auto;
                    transform: none;
                    float: left;
                    .prevLength{
                        float: left;
                        width: 1.6rem;
                        height: 100%;
                        background: url('../../static/img/prevLength.png') no-repeat center center;
                        background-size: 1.6rem 1.6rem;
                        cursor: pointer;
                        margin-left: 0px;
                    }
                    .nextLength{
                        float: left;
                        width: 1.6rem;
                        height: 100%;
                        background: url('../../static/img/nextLength.png') no-repeat center center;
                        background-size: 1.6rem 1.6rem;
                        cursor: pointer;
                        margin-left: 1.11rem;
                    }
                    .player-btn{
                        float: left;
                        width: 1.11rem;
                        height: 100%;
                        cursor: pointer;
                        margin-left: 1.11rem;
                        &.pause{
                            background: url('../../static/img/play-btn-white.png') no-repeat center center;
                            background-size: 1.11rem 1.38rem;
                        }
                        &.play{
                            background: url('../../static/img/pause-btn-white.png') no-repeat center center;
                            background-size: 1.11rem 1.38rem;
                        }
                    }
                    .prevList{
                        display: none;
                    }
                    .nextList{
                        display: none;
                    }
                }
                .showName-m{
                    display: block;
                    float: left;
                    height: 100%;
                    margin-left: 1.67rem;
                    width: 11.2rem;
                    overflow: hidden;
                    position: relative;
                    .columnName-m{
                        float: left;
                        height: 100%;
                        color: #ffffff;
                        font: 400 .89rem/3.72rem HelveticaLTPro-Bold;
                        margin-left: 1.67rem;
                        width: 5.44rem;
                        overflow: hidden;
                    }
                    .showName-m-con{
                        height: 100%;
                        margin: 0;
                        padding: 0;
                        position: relative;
                        color: #ffffff;
                        font: 400 .78rem/3.72rem HelveticaLTPro-Roman;
                        white-space: nowrap;
                        .showName-m-item{
                            display: inline-block;
                            pointer-events: none;
                            &.hoverClass{
                                cursor: pointer;
                                pointer-events: auto;
                            }
                            &.copy{
                                display: none;
                                margin-left: 10px;
                            }
                        }
                    }
                }
                .speed-pc{
                    display: none;
                }
                .speed-pad{
                    display: block;
                    float: left;
                    margin-left: 1.6rem;
                    position: relative;
                    .speed-pad-con{
                        width: 1.6rem;
                        height: 1.6rem;
                        font: 400 .56rem/1.55rem HelveticaLTPro-Roman;
                        color: #fff;
                        text-align: center;
                        border: 2px solid #fff;
                        border-radius: 50%;
                        margin-top: 1.06rem;
                        cursor: pointer;
                        user-select: none;
                    }
                    ul{
                        width: 1.6rem;
                        border: 2px solid #fff;
                        border-radius: .8rem;
                        background-color: rgba(0, 0, 0, 0.85);
                        position: absolute;
                        transform: translate(-.16rem, -8rem);
                        box-sizing: initial;
                        padding: .67rem 0;
                        display: none;
                        li{
                            text-align: center;
                            margin-top: .56rem;
                            cursor: pointer;
                            user-select: none;
                            &:first-child{
                                margin-top: 0px;
                            }
                            span{
                                display: block;
                                font: 400 .56rem/.67rem HelveticaLTPro-Roman;
                                color: #fff;
                            }
                            &:hover{
                                span{
                                    color: #d6bd59;
                                }
                            }
                            &.active{
                                span{
                                    color: #d6bd59;
                                }
                            }
                        }
                        &.active{
                            display: block;
                        }
                    }
                }
                .share-btn{
                    display: none;
                }
                .share-btn-pad{
                    display: block;
                    float: left;
                    margin-left: .6rem;
                    width: 1.6rem;
                    height: 100%;
                    background: url('../../static/img/share.png') no-repeat center center;
                    background-size: 1.6rem 1.6rem;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
<style lang="scss">
    @keyframes playerTitleScroll{
        0% {transform: translateX(0%);}
        100% {transform: var(--playerTitleScrollStyle);}
    }
    .player{
        .cg-mainWrapper{
            .playerCon{
                .showName{
                    .showName-con{
                        &.scroll{
                            animation: playerTitleScroll 10s linear infinite;
                            .showName-item{
                                pointer-events: none;
                                &.hoverClass{
                                    cursor: pointer;
                                    pointer-events: auto;
                                }
                                &.copy{
                                    display: inline-block;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 768px){
    .player{
        .cg-mainWrapper{
            .playerCon{
                .showName-m{
                    span{
                        &.scroll{
                            animation: playerTitleScroll 12s linear infinite;
                        }
                    }
                    .showName-m-con{
                        &.scroll{
                            animation: playerTitleScroll 15s linear infinite;
                            .showName-m-item{
                                pointer-events: none;
                                &.hoverClass{
                                    cursor: pointer;
                                    pointer-events: auto;
                                }
                                &.copy{
                                    display: inline-block;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue